/**
 * Shared primitive for the navigation icon set.
 *
 * Every glyph is drawn on a 24x24 grid with a 3-21 live area, a 1.5 stroke and
 * round terminals, so a row of them shares one optical weight and centre.
 *
 * Two things are deliberate:
 *  - `stroke="currentColor"` — the icons inherit the colour of whatever renders
 *    them, which is what lets the top bar tint the active item. The old set
 *    hardcoded #0D0D0D and silently ignored it.
 *  - `size` drives both width and height, so callers control the rendered size
 *    rather than each file baking in its own.
 */
const IconBase = ({ size = 24, strokeWidth = 1.5, title, children, ...rest }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        xmlns="http://www.w3.org/2000/svg"
        role={title ? "img" : undefined}
        aria-hidden={title ? undefined : true}
        focusable="false"
        {...rest}
    >
        {title ? <title>{title}</title> : null}
        {children}
    </svg>
);

export default IconBase;
